var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProwessIcon5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 74,
    viewBox: "0 0 74 74",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1311 -1773)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 74,
    rx: 10,
    transform: "translate(1311 1773)",
    fill: "#ffbe8d"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5,
    cy: 5,
    r: 5,
    transform: "translate(1357 1788)",
    fill: "#621bc0"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(382.5 2024.857)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(933 -247.357)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.7,33.2a10.5,10.5,0,1,0,10.5,10.5A10.52,10.52,0,0,0,43.7,33.2Zm0,15.683A5.186,5.186,0,1,1,48.883,43.7,5.173,5.173,0,0,1,43.7,48.883Z",
    transform: "translate(-11.518 -11.518)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.171,29.492H53.422A21.482,21.482,0,0,0,34.865,10.935V5.187a2.687,2.687,0,1,0-5.373,0v5.748A21.482,21.482,0,0,0,10.935,29.492H5.187a2.687,2.687,0,1,0,0,5.373h5.748A21.482,21.482,0,0,0,29.492,53.422v5.748a2.687,2.687,0,0,0,5.373,0V53.422A21.482,21.482,0,0,0,53.422,34.865h5.748a2.687,2.687,0,0,0,0-5.373ZM32.179,48.236A16.058,16.058,0,1,1,48.236,32.179,16.053,16.053,0,0,1,32.179,48.236Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProwessIcon5);
export default __webpack_public_path__ + "static/media/prowess-icon5.607f5ef62028233682c7ff5c0be4d158.svg";
export { ForwardRef as ReactComponent };